import React from 'react';
import PrivateRoute from 'PrivateRoutes';
const REPORT = React.lazy(()=> import(/* webpackChunkName: "UserSummaryReports" */'./components'));

const routes = () => (
  <PrivateRoute exact path="/reporting/user-summary" component={REPORT} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/reporting/UserSummery/routes.js